export default __webpack_public_path__ + "static/hyperse-73cb0e753921d7caf3bb83e75ee5781e.png";